<template>
  <v-container class="base-page-layout pb-4" fluid>
    <v-container v-show="!hideHeader" class="pa-0 mb-3 page-actions" fluid fill-height>
      <v-layout align-center>
        <breadcrumbs v-if="$vuetify.breakpoint.smAndUp && !hideBreadcrumbs" class="breadcrumbs" />
        <v-spacer />
        <ultima-atualizacao v-if="!isMobile" />
      </v-layout>
      <v-row>
        <mf-button v-if="showBackButton" class="ma-0 ml-3" text color="marca-0-l40" label="Voltar" icon="arrow_back" @click="goBack" />
      </v-row>
    </v-container>
    <v-layout v-if="title && !hideHeader">
      <div class="d-flex align-center base-title-section">
        <span v-if="title && title.length" data-cy="pageTitle" class="page-title">{{ title }}</span>
        <slot name="title-complement"></slot>

        <div class="page-status">
          <slot name="page-status"></slot>
        </div>
      </div>

      <v-tooltip bottom class="text-left help-icon">
        <template v-slot:activator="{ on }">
          <span v-if="$slots['title-tooltip']" v-on="on">
            <mf-icon small class="mb-1 ml-1" color="cinza-0">info</mf-icon>
          </span>
        </template>
        <slot name="title-tooltip"></slot>
      </v-tooltip>

      <v-spacer />
      <slot name="card-extra"></slot>
      <start-tour-button v-if="showTour" :loading-tutorial="loadingTutorial" :tour-index="tourIndex" :flow-id="flowId" />
      <slot name="header"></slot>
      <template v-if="filters && filters.length && !useNewFilters">
        <filters-menu
          :filters="filters"
          :max-filter-days="maxFilterDays"
          :default-date="defaultDate"
          :check-all-units-on-init="checkAllUnitsOnInit"
          :set-campaigns-date-range="setCampaignsDateRange"
          :campaigns-filters-status="campaignsFiltersStatus"
          :hide-ecommerce-configuration="hideEcommerceConfiguration"
          :filter-to-units="filterToUnits"
          :use-campaign-frequency="useCampaignFrequency"
          :use-filter-button="useFilterButton"
          @confirm-select-units="$emit('confirm-select-units', $event)"
        />
      </template>
    </v-layout>
    <v-layout v-if="$slots.filters" class="pb-2">
      <v-spacer />
      <slot name="header"></slot>
      <!-- filtros no novo padrão da plataforma. O layout externo dos filtros fica na base-page-layout para manter um design consistente e os filtros são implementados usando o slot 'filters'. filters-menu (acima) será removido futuramente -->
      <filters-menu-v2 :filters-quantity="filtersQuantity" @apply-filters="$emit('apply-filters')" @clear-filters="$emit('clear-filters')">
        <slot name="filters"></slot>
      </filters-menu-v2>
    </v-layout>
    <v-layout v-if="$slots['custom-filters']" class="pb-2">
      <slot name="header"></slot>
      <v-spacer />
      <slot name="custom-filters"></slot>
    </v-layout>

    <template v-if="filters && filters.length && useNewFilters">
      <new-filters-menu
        :filters="filters"
        :filter-to-units="filterToUnits"
        :check-all-units-on-init="checkAllUnitsOnInit"
        :clear-filter-on-init="clearFilterOnInit"
        @ecommerce-config-changed="$emit('ecommerce-config-changed', $event)"
      />
    </template>
    <slot></slot>
  </v-container>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import UltimaAtualizacao from '@/components/last-updated/UltimaAtualizacao.vue'

export default {
  components: {
    Breadcrumbs,
    UltimaAtualizacao,
    StartTourButton: () => import('@/components/tour/StartTourButton.vue'),
    FiltersMenu: () => import('@/components/FiltersMenu.vue'),
    FiltersMenuV2: () => import('@/components/FiltersMenuV2.vue'),
    NewFiltersMenu: () => import('@/components/filters-menu/NewFiltersMenu.vue'),
  },
  props: {
    title: {
      type: String,
    },
    backRouter: {
      type: String,
      default: '',
    },
    hideBreadcrumbs: {
      type: Boolean,
    },
    showBackButton: {
      type: Boolean,
    },
    filters: {
      type: Array,
    },
    filtersQuantity: {
      type: Number,
    },
    defaultDate: {
      type: String,
    },
    maxFilterDays: {
      type: Number,
      default: null,
    },
    checkAllUnitsOnInit: {
      type: Boolean,
      default: true,
    },
    setCampaignsDateRange: {
      type: Boolean,
      default: false,
    },
    hideEcommerceConfiguration: {
      type: Boolean,
      default: false,
    },
    campaignsFiltersStatus: {
      type: Array,
      default: () => ['ACTIVE', 'FINISHED'],
    },
    useCampaignFrequency: {
      type: Boolean,
      default: false,
    },
    useNewFilters: {
      type: Boolean,
      default: false,
    },
    clearFilterOnInit: {
      type: Boolean,
      default: false,
    },
    filterToUnits: {
      type: Array,
      default: () => [],
    },
    showTour: {
      type: Boolean,
    },
    loadingTutorial: {
      type: Boolean,
    },
    tourIndex: {
      type: Number,
      default: 0,
    },
    flowId: {
      type: String,
      default: '',
    },
    useFilterButton: {
      type: Boolean,
      default: false,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tab: 0,
  }),
  computed: {
    onlyMercapromo() {
      return this.$getLoggedUser().only_mercapromo
    },
  },
  methods: {
    goBack() {
      if (!this.backRouter.length) {
        this.$router.go(-1)

        return
      }

      this.$router.push(this.backRouter)
    },
  },
}
</script>
<style lang="scss">
.base-page-layout {
  .alerta {
    font-weight: bold;
    position: absolute;
    top: 0;
    margin: 0;
    left: 0;
    width: 100%;
    padding: 8px;
    border-radius: 0px;
    a {
      color: $branco;
    }
  }
  .base-title-section {
    min-height: 58px;
    padding-bottom: 16px;
  }
  .page-status {
    margin-left: 24px;
    margin-bottom: 16px;
  }
  .unset-capitalize {
    text-transform: unset !important;
    letter-spacing: $letterspacing-1;
  }
}
@media print {
  .page-actions {
    display: none !important;
  }
}
@media print {
  .page-actions {
    display: none !important;
  }
}
</style>
